import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';

import ValidationNomination from '../Validation/ValidationNomination';
import WizardWrapper from './WizardWrapper';
import useWizardForm from './useWizardForm';
import useNominationWizard from './useNominationWizard';
import { useAdminCollections } from '../../../../context/AdminCollections';
import { useLoggedInUserContextProvider } from '../../../../context/LoggedInUserContext';
import ModalAlert from '../../ModalAlert';
import ModalConfirmation from '../../ModalConfirmation';

const WizardNomination = () => {
  const { userDetails } = useLoggedInUserContextProvider();
  const {
    nominationArray,
    nominationStateArray,
    candidateArray,
    draftNominationArray,
    proposerSeconder,
  } = useAdminCollections();

  const {
    setValue,
    watch,
    resetField,
    errors,
    trigger,
    setHideButtons,
    wrapperProps,
  } = useWizardForm({
    defaultValues: {
      phdAwardedYear: '1959',
      electionTypeId: '2',
    },
    resolver: yupResolver(ValidationNomination, {
      candidateArray: candidateArray || [],
      nominationArray: nominationArray || [],
      nominationStateArray: nominationStateArray || [],
      draftNominationArray: draftNominationArray || [],
      proposerSeconder: proposerSeconder || [],
      currentUserId: userDetails?.id,
      isAdmin:
        userDetails?.roles?.includes('admin') ||
        userDetails?.roles?.includes('super-admin'),
    }),
  });

  const {
    nominationStatusId,
    notification,
    showNotification,
    submitPending,
    pendingElectionChange,
    handleElectionTypeConfirm,
    handleElectionTypeCancel,
    onSubmit,
  } = useNominationWizard({
    setValue,
    watch,
    resetField,
    trigger,
    setHideButtons,
    errors,
  });

  return (
    <>
      <ModalAlert
        show={notification !== null}
        onClose={() => showNotification(null, null)}
        title={notification?.title ?? ''}
        message={notification?.message ?? ''}
        icon='bi-exclamation-triangle-fill'
        iconColor='text-danger'
      />

      <ModalConfirmation
        showModal={pendingElectionChange !== null}
        handleCancelSelect={handleElectionTypeCancel}
        handleConfirmSelect={handleElectionTypeConfirm}
        bodyText={
          pendingElectionChange
            ? `Changing the **Election Type** will clear the following fields:\n\n${pendingElectionChange.fields
                .map((f) => `- ${f}`)
                .join('\n')}\n\nDo you want to continue?`
            : ''
        }
      />

      <WizardWrapper
        {...wrapperProps}
        activeMenu='Nomination'
        motherMenu='Home'
        formName='nomination'
        onSubmit={onSubmit}
        formStatusId={nominationStatusId}
        requireConfirmation
        submitPending={submitPending}
      />
    </>
  );
};

export default WizardNomination;
